import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FloatLabelType, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-text-area-input',
  templateUrl: './text-area-input.component.html',
  styleUrls: ['./text-area-input.component.scss'],
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
})
export class TextAreaInputComponent implements OnInit, OnDestroy {
  @Input() label!: string;
  @Input() rows: string = '1';
  @Input() control!: FormControl;
  @Input() placeholder!: string;
  @Input() floatLabel: FloatLabelType = 'auto';
  @Input() value: string = '';
  @Input() autoAdjustHeightSmall: boolean = false;

  characterCountNewRow: number = 0;

  private destroy$ = new Subject<void>();
  private onInputChange$ = new Subject<string>();

  ngOnInit(): void {
    if (this.autoAdjustHeightSmall) {
      this.characterCountNewRow = 23;
    }

    this.updateRows();

    this.onInputChange$.pipe(debounceTime(10), takeUntil(this.destroy$)).subscribe(() => {
      this.updateRows();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onInputChange(newValue: any): void {
    if (typeof newValue === 'string') {
      this.onInputChange$.next(newValue);
    }
  }

  private updateRows(): void {
    if (this.autoAdjustHeightSmall && this.control.value) {
      const text = this.control.value as string;
      const lines = Math.ceil(text.length / this.characterCountNewRow);
      this.rows = lines.toString();
    }
  }
}
